import {
  ACCOMMODATION_FORMS_NUMBERS,
  ACCOMMODATION_FORMS_ORDER
} from 'pages/create-accommodation/constants';

export const isNextStepAvailable = (
  forms,
  languages,
  newActiveTab,
  savedForms,
  pricesActiveSubTab
) => {
  let newActiveTabCopy = newActiveTab;

  while (newActiveTabCopy > 0) {
    let formName = ACCOMMODATION_FORMS_ORDER[newActiveTabCopy - 1];

    if (typeof formName === 'object') {
      formName = formName[pricesActiveSubTab];
    }

    const languagesLength = languages.length;
    const secondLanguage = languages[languagesLength - 1];

    if (languagesLength > 1 && formName === 'addOnsForm') {
      const addOnsSecondLanguageForm = forms[formName].values;
      for (let i in addOnsSecondLanguageForm.addOns) {
        if (!addOnsSecondLanguageForm.addOns.hasOwnProperty(i)) continue;
        const addOns = addOnsSecondLanguageForm.addOns[i][secondLanguage];
        if (!addOns.title) return false;
      }
    }

    if (languagesLength > 1 && formName === 'mandatoryFeesForm') {
      const mandatoryFeesSecondLanguageForm = forms[formName].values;
      for (let i in mandatoryFeesSecondLanguageForm.mandatoryFees) {
        if (!mandatoryFeesSecondLanguageForm.mandatoryFees.hasOwnProperty(i)) continue;
        const mandatoryFees = mandatoryFeesSecondLanguageForm.mandatoryFees[i][secondLanguage];
        if (!mandatoryFees.title) return false;
      }
    }

    if (
      languagesLength > 1 &&
      (formName === 'generalForm' || formName === 'descriptionForm')
    ) {
      const secondLanguageFormName = `${formName}-${secondLanguage}`;
      if (
        languagesLength > 1 &&
        forms[secondLanguageFormName] &&
        (forms[secondLanguageFormName].syncErrors ||
          !Object.keys(savedForms[secondLanguageFormName]).length)
      ) {
        return false;
      }
    }

    if (
      forms[formName] &&
      (forms[formName].syncErrors || !savedForms[formName])
    ) {
      return false;
    }

    newActiveTabCopy--;
  }

  return true;
};

export const isCurrentStepAvailable = (
  forms,
  activeTab,
  pricesActiveSubTab
) => {
  let activeFormName = '';

  if (activeTab === ACCOMMODATION_FORMS_NUMBERS.pricesForm) {
    activeFormName = ACCOMMODATION_FORMS_ORDER[activeTab][pricesActiveSubTab];
  } else {
    activeFormName = ACCOMMODATION_FORMS_ORDER[activeTab];
  }

  if (forms[activeFormName].syncErrors) {
    return false;
  }

  return true;
};
